import { createSelector } from 'reselect';

export const selectOrgFeatures = () => (state) =>
  state.getIn(['global', 'orgFeatures']);

export const selectOrgHasFeatureCode = (code) =>
  createSelector(selectOrgFeatures(), (orgFeatures) =>
    orgFeatures?.some((f) => f.get('code') === code),
  );
